import { CHANGE_AUTH_FLAG, AUTH_LOGOUT, GET_PROFILE } from "./action-types";

const initialState = {
  isAuthenticated: false,
  token: "",
  profile: "",
};

export const userAuthentication = (
  state = initialState,
  { type, payload, authToken = null }: any
): any => {
  switch (type) {
    case CHANGE_AUTH_FLAG:
      return changeAuthFlag(state, payload, authToken);
    case AUTH_LOGOUT:
      return authLogout(state);
    case GET_PROFILE:
      return getProfile(payload);
    default:
      return state;
  }
};

function changeAuthFlag(
  state: any,
  payload: boolean,
  authToken: any,
) {
  return {
    ...state,
    isAuthenticated: payload,
    token: authToken,
  };
}
function authLogout(state: any) {
  return {
    ...state,
    isAuthenticated: false,
    token: "",

  };
}

function getProfile(payload: any) {
  return {
    // ...state,
    payload
  };
}
